import React from 'react'

const PathContext = React.createContext<string>('')

export function PathProvider({children, path}: React.PropsWithChildren<{path: string}>) {
  return <PathContext value={path}>{children}</PathContext>
}

export function usePath() {
  return React.use(PathContext)
}
